export default {
	title: 'Fundamentals',
	subtitle:
		'List the fundamental parameters that qualify the « what » and « how », for example values, principles, short vision or strategic slogan. Note that you can weigh them. Then click « next ». You can also skip this step.',
	no_description: 'No defined goal',
	context_worse: 'Negative',
	context_best: 'Positive',
}
